export interface ClientAccountWillExecutor {
    id?: string | null;
    name: string | null;
    telephone: string | null;
    email: string | null;
    addressLine1: null;
    addressLine2: null;
    addressLine3: null;
    town: null;
    county: null;
    postcode: null;
    isProfessionalExecutor?: boolean | null;
    isRLGExecutor?: boolean | null;
    isFirstOrSubstituteExecutor?: boolean | null;
    isSoleOrCoExecutor?: boolean | null;
    displayOrder?: number;
    version?: number;
}

export function createClientAccountWillExecutor(): ClientAccountWillExecutor {
    return {
        name: null,
        telephone: null,
        email: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        town: null,
        county: null,
        postcode: null,
        isProfessionalExecutor: null,
        isRLGExecutor: null,
        isFirstOrSubstituteExecutor: null,
        isSoleOrCoExecutor: null,
    };
}
